import { normalizeEmail } from "@/lib/userSession";

export const LOCALHOST_TEST_CLIENT_EMAIL = "customer@localhost.test";
export const LOCALHOST_TEST_CLIENT_KEY = `email:${LOCALHOST_TEST_CLIENT_EMAIL}`;
export const LOCALHOST_TEST_CLIENT_LABEL = LOCALHOST_TEST_CLIENT_EMAIL;

export const shouldRestrictToLocalhostCustomer = (localhostRuntime = false) => Boolean(localhostRuntime);

export const getLocalhostAdminClient = () => ({
  key: LOCALHOST_TEST_CLIENT_KEY,
  id: "",
  email: LOCALHOST_TEST_CLIENT_EMAIL,
  label: LOCALHOST_TEST_CLIENT_LABEL,
  profileSource: "localhost-default",
});

export const isVisibleAdminClient = (row, localhostRuntime = false) => {
  const email = normalizeEmail(row?.email || row?.email_normalized || "");
  if (!email) return false;
  if (!shouldRestrictToLocalhostCustomer(localhostRuntime)) return true;
  return email === LOCALHOST_TEST_CLIENT_EMAIL;
};

export const filterVisibleAdminClients = (rows = [], localhostRuntime = false) => {
  if (!Array.isArray(rows)) return [];
  return rows.filter((row) => isVisibleAdminClient(row, localhostRuntime));
};

export const resolveAdminClientFromSelection = ({
  clients = [],
  clientKey = "",
  selectedMeta = null,
  selectedLabel = "",
  localhostRuntime = false,
} = {}) => {
  const normalizedKey = String(clientKey || "");
  const storedEmail = normalizeEmail(selectedMeta?.email || "");
  const labelEmailMatch = String(selectedLabel || "").match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i);
  const labelEmail = normalizeEmail(labelEmailMatch?.[0] || "");

  const visibleClients = filterVisibleAdminClients(clients, localhostRuntime);
  const byKey = visibleClients.find((row) => String(row?.key || "") === normalizedKey) || null;
  if (byKey) return byKey;

  const byEmailValue = visibleClients.find((row) => normalizeEmail(row?.email || "") === normalizedKey) || null;
  if (byEmailValue) return byEmailValue;

  if (labelEmail) {
    const byLabelEmail = visibleClients.find((row) => normalizeEmail(row?.email || "") === labelEmail) || null;
    if (byLabelEmail) return byLabelEmail;
  }

  if (storedEmail) {
    const byStoredEmail = visibleClients.find((row) => normalizeEmail(row?.email || "") === storedEmail) || null;
    if (byStoredEmail) return byStoredEmail;
  }

  if (localhostRuntime && (normalizedKey === `email:${LOCALHOST_TEST_CLIENT_EMAIL}` || normalizedKey === LOCALHOST_TEST_CLIENT_EMAIL)) {
    return getLocalhostAdminClient();
  }

  return null;
};
